module.exports = __webpack_public_path__ + "media/images/static_page/bg_block_grey-48d4315b706f162c6bdbdf54c7f1e060.png";